import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { TrabalhadorEstrangeiroDTO } from "../../components/recadastramento-aba5/trabalhadorEstrangeiroDTO";
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";

@Injectable()
export class TrabalhadorEstrangeiroAba5Service extends GenericService {

    private basePath = 'api/v1';
    private path = '/trabalhador-estrangeiro';
    url = environment.url;

    constructor(http: HttpClient) {
        super(http);
    }

    getTrabalhadorEstrangeiro(): Observable<TrabalhadorEstrangeiroDTO> {
        return this.http.get<TrabalhadorEstrangeiroDTO>(this.url + this.basePath + this.path);
    }

    salvarDadosTrabalhadorEstrangeiro(data): Observable<any> {
        return this.http.patch(this.url + this.basePath + this.path, data);
    }

    deletarComprovanteEstrangeiro(): Observable<ArquivoBlobDTO> {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.put<ArquivoBlobDTO>(this.url + this.basePath + '/comprovante-deletar/condicao-ingresso-estrangeiro', options);
    }

    getVisualizarComprovante(): Observable<ArquivoBlobDTO> {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>(this.url + this.basePath + '/visualizar_comprovante/condicao-ingresso-estrangeiro', options);
    }


    uploadComprovanteEstrangeiro(file: File) {
        const formData = new FormData();
        formData.append('multipartFile', file);
        return this.patchMethodFile(this.url + this.basePath + '/upload_comprovante/condicao-ingresso-estrangeiro', formData);
    }
}
